var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 72,
    height: 72,
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABaUExURQAAAAbCYAfAYAi/YAfBYAi/YAfCYAfAYAjBYAjC YAfBYAfBYAfBYAfBYAbBYAbBYAW/YAfCYAC/YAfBYAbAYAjBYQfBYAfBYAjCYQfBYAfCYAbCYQfB YP///8zuv6gAAAAcdFJOUwBQryDvQHDQgGDAsJDfoH8wvxDwn1/Pbz+P4E8SOWO4AAAAAWJLR0Qd 6wNxkQAAAAd0SU1FB+kJGAkNBa83TKYAAAITSURBVFjD7ZfbloMgDEWxQIvoKEJv08n/f+dQxWq5 RFtcMy89D7ZrETeChyQS8tFH/6hiV2zDAQC6BYhZEN8CZDmw3wJ0sCCRTSk5kRZUZXPsomoLktkc uyhhQV/ZHGj6K2Rz7KI4ZBqpvQPsohRkGYl2MGgw0tuHpGCOA5qY942kxsfpFyXfBdEjzFT0oDeM xJ8wo5FeBenTGSAGeslI6rKDULJPSCtB+npqOwZROUcq/P5r23ZdNXguIUb0/ef8fdERwKU9do/d OA+eS+kxygJX8iDUICBFbuPf0gMJL1T3VkmJT6PMW50MQisEVM5GvUdiAUggIDEb9U4KFhqqIfvE E6kQxBGQnI3O9kj/tEcsNNR5Gp2tTMf8K1caqUbefC+Gg3Q/aqqndBvfVbJgpEixjW+GWuFILyPR RGiNgES02Npidbj5oeUKR7JYBgtDCwQk08XWf6RmjSNjqU0EoRQBsXSx9W+zqc1IKStR2WtIQrq2 ZooyQvDnySgX1VOmo+liSw+yFsPcTMcCCBfTRi51be7ltW2iQ1CNGd2xUGzHOVkqQAszGQnp2h4J qyRpFNxP/UKxfbw8rGmlckXX5rK6xLvfvUttSNfmDoYiuNRQbEskxLgTsigAvNmqMSvN1QD+QaKW 3tq0UUai0x3Gs5ar/XiacqUHUJ0NcnmA5YOclTb4/L0tHpKVKoPE9tFHf6FfNp6YeDMxsmIAAAAl dEVYdGRhdGU6Y3JlYXRlADIwMjUtMDktMjRUMDk6MTM6MDUrMDA6MDBmT5EjAAAAJXRFWHRkYXRl Om1vZGlmeQAyMDI1LTA5LTI0VDA5OjEzOjA1KzAwOjAwFxIpnwAAACh0RVh0ZGF0ZTp0aW1lc3Rh bXAAMjAyNS0wOS0yNFQwOToxMzowNSswMDowMEAHCEAAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushMessage);
export default __webpack_public_path__ + "static/media/pushMessage.43ff35de.svg";
export { ForwardRef as ReactComponent };